import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import {
	SPACE_MANAGER_ANALYTICS_SOURCE,
	SpaceManagerLoader,
} from '@confluence/space-manager/entry-points/SpaceManagerLoader.tsx';

// Note that "Space Manager" is a global settings page that shows all the spaces in the instance.
// Thus we don't need to pass in a spaceKey or render the <SpaceBase> component.

export const SpaceManagerRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <SpaceManagerLoader />;

SpaceManagerRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: SPACE_MANAGER_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
